import { useContext } from 'react';
import { RearrangeContext } from '../Contexts/RearrangeContext';
export default function useRearrangeContext() {
    const context = useContext(RearrangeContext);
    if (!context) {
        throw new Error('useRearrangeContext must be used within a RearrangeContextProvider');
    }
    return context;
}
